import React from 'react'
import InfoIcon from '@mui/icons-material/Info'
import { IconButton } from '@mui/material'
import { GridColDef } from '@mui/x-data-grid'
import { Toolbar } from 'common/AbstractDataGridToolbar/CustomToolbar'
import { DataCDRPackageDetailType } from 'types/api/faber/dataUsage.type'

import { CustomTooltip } from './CustomTooltip'
import RolloverTooltipTable from './RolloverTooltipTable'

interface DataUsageType {
  usageRows: DataCDRPackageDetailType[]
  usageColumns: GridColDef[]
  calculateTotal: boolean
  filterProps?
  toolbar: boolean
}

export default function DataUsageTooltip({
  usageRows,
  usageColumns,
  calculateTotal,
  filterProps,
  toolbar
}: DataUsageType) {
  return (
    <CustomTooltip
      disableFocusListener
      title={
        <RolloverTooltipTable
          header='Usage Breakdown'
          rows={usageRows}
          columns={usageColumns}
          calculateTotal={calculateTotal}
          sx={{ ml: '20px', overflow: 'auto' }}
          dgDimensions={{ width: '750px', height: '250px' }}
          dgComponents={toolbar ? { Toolbar: Toolbar } : null}
          dgComponentsProps={{
            toolbar: {
              filterProps: filterProps,
              searchBar: 'disabled',
              menuSx: { left: '-230px', top: '-80px' }
            }
          }}
        />
      }
      placement='top'
    >
      <IconButton>
        <InfoIcon sx={{ fontSize: '12px' }} />
      </IconButton>
    </CustomTooltip>
  )
}
